import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Article, QuestionAnswer } from '@mui/icons-material';

interface ModalTabsProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  showChatTab?: boolean;
}

// The live "Document Preview" tab was removed — the processing modal now only
// shows progress (Processing Steps); the finished document shows in the tool's
// own output panel. The only secondary tab is the premium Document Chat.
export const ModalTabs: React.FC<ModalTabsProps> = ({
  activeTab,
  onTabChange,
  showChatTab = false,
}) => {
  return (
    <Box sx={{ borderBottom: '1px solid #e5e7eb', bgcolor: 'white' }}>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        sx={{
          minHeight: 48,
          '& .MuiTab-root': {
            minHeight: 48,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem'
          }
        }}
      >
        <Tab
          label="Processing Steps"
          icon={<Article sx={{ fontSize: '1.125rem' }} />}
          iconPosition="start"
          sx={{ gap: 1 }}
        />
        {showChatTab && (
          <Tab
            label="Document Chat"
            icon={<QuestionAnswer sx={{ fontSize: '1.125rem' }} />}
            iconPosition="start"
            sx={{ gap: 1 }}
          />
        )}
      </Tabs>
    </Box>
  );
};
